import React from 'react';

import { Content, Header, ShimmerEffect } from './styles';

const LoadingComponent: React.FC = () => {
  return (
    <>
      <Header>
        <ShimmerEffect className="header-shimmer" />
      </Header>
      <Content>
        <ShimmerEffect className="content-shimmer" />
      </Content>
    </>
  );
};

export default LoadingComponent;
